module.exports = "/assets/Inter-Medium.d0a58d95.woff2";